var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('image-field', _vm._b({
    staticClass: "editable-image",
    attrs: {
      "value": _vm.imageUrl,
      "message": _vm.message
    },
    on: {
      "readFile": function (param, file) {
        _vm.saveImage(param, file)
      },
      "input": _vm.handleInput
    }
  }, 'image-field', {
    model: _vm.model,
    attribute: _vm.attribute,
    editable: _vm.editable,
    removable: _vm.removable,
    recommendations: _vm.recommendations,
    resizable: _vm.resizable
  }, false), [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.saving),
      expression: "saving"
    }],
    staticClass: "loading"
  })])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ea99356c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/components/editable-image.vue
// module id = null
// module chunks = 